const truthy = (value) => ["1", "true", "yes", "on"].includes(String(value || "").toLowerCase());

const runtimeConfig = window.__APP_CONFIG__ || {};

export const features = {
  flow3: truthy(runtimeConfig.FLOW_3_ENABLED ?? process.env.REACT_APP_FLOW_3_ENABLED ?? "true"),
};
